import axios from 'axios';
import { getSession } from './auth';

export const postBillingRequest = async (url, data, onSignInRequired) => {
    if (!getSession()) {
        onSignInRequired();
        const error = new Error('Sign in is required to save this bill.');
        error.response = { status: 401 };
        throw error;
    }
    try {
        return await axios.post(url, data);
    } catch (error) {
        if (error.response?.status === 401) onSignInRequired();
        throw error;
    }
};

export const billingErrorMessage = (error, fallback) => {
    if (error.response?.status === 401) return 'Please sign in again. Your current bill has been kept.';
    if ([403, 409].includes(error.response?.status)) return error.response.data?.error || fallback;
    return fallback;
};
